import { useCallback, useRef } from 'react';
import { LayerGroup } from 'react-leaflet';
import AssetTablePositionMarker from '../markers/asset-table-position-marker/AssetTablePositionMarker';
import { useSiteMapFocus } from '@casops/routes/home/useSiteMapFocus';
import { ASSET_KEY, HOME_OVERVIEW_ASSETS } from '@casops/navigation';
import MarkerClusterGroup from 'react-leaflet-cluster';
import 'react-leaflet-cluster/dist/assets/MarkerCluster.css';
import 'react-leaflet-cluster/dist/assets/MarkerCluster.Default.css';
import useMapProvider from '@casops/components/maps/hooks/useMapProvider';
import * as L from 'leaflet';
import { LiveAssetsMarkersProps, useLiveAssetsMarkers } from '../markers/useLiveAssetsMarkers';

export function MultipleAssetPositionLayer({ assets, assetsLocations }: LiveAssetsMarkersProps) {
  const clusterGroupRef = useRef<L.MarkerClusterGroup>(null);
  const { maxZoom, maxNativeZoom } = useMapProvider();
  const minMaxZoom = Math.min(maxZoom, maxNativeZoom);

  const markerProps = useLiveAssetsMarkers({ assets, assetsLocations });

  const { value: urlAssetId, focus: assetFocus } = useSiteMapFocus({
    paramKey: ASSET_KEY,
    pathname: HOME_OVERVIEW_ASSETS,
  });

  const onClick = useCallback(
    (id: number): void => {
      if (typeof id === 'number') {
        assetFocus(id);
      }
    },
    [assetFocus],
  );

  return (
    <LayerGroup>
      <MarkerClusterGroup ref={clusterGroupRef} chunkedLoading disableClusteringAtZoom={minMaxZoom}>
        {markerProps.map(({ id, position, heading, label, obj }) => {
          const isSelected = typeof urlAssetId === 'number' && id === urlAssetId;
          return (
            <AssetTablePositionMarker
              key={id}
              id={id}
              position={position}
              heading={heading}
              obj={obj}
              label={label}
              onClick={() => onClick(id)}
              isSelected={isSelected}
              clusterGroupRef={clusterGroupRef}
            />
          );
        })}
      </MarkerClusterGroup>
    </LayerGroup>
  );
}

export default MultipleAssetPositionLayer;
